/**
 * Analytics IDs for CTAs.
 *
 * Separate by module and sort alphabetically.
 */
export const ANALYTICS_IDS = {
    careers: {
        click_menu_careers: 'click_menu_careers',
        click_menu_careers_BNBChainCareers: 'click_menu_careers_BNBChainCareers',
        click_menu_careers_EcosystemJobs: 'click_menu_careers_EcosystemJobs',
    },
    community: {
        click_menu_community: 'click_menu_community',
        click_menu_community_communityHub: 'click_menu_community_communityHub',
        click_menu_community_blog: 'click_menu_community_blog',
        click_menu_community_events: 'click_menu_community_events',
        click_menu_community_BNBBuilderAlliance: 'click_menu_community_BNBBuilderAlliance',
        click_menu_community_forum: 'click_menu_community_forum',
        click_menu_community_martiansProgram: 'click_menu_community_martiansProgram',
        click_menu_community_buildersClub: 'click_menu_community_buildersClub',
        click_menu_community_SpaceB: 'click_menu_community_SpaceB',
        click_menu_community_Governance: 'click_menu_community_Governance',
    },
    contact: {
        click_menu_contactUs: 'click_menu_contactUs',
        click_menu_developerHome: 'click_menu_developerHome',
    },
    developers: {
        click_menu_developers: 'click_menu_developers',
        click_menu_dev_developerHome: 'click_menu_dev_developerHome',
        click_menu_dev_documentation: 'click_menu_dev_documentation',
        click_menu_dev_devProgs: 'click_menu_dev_devProgs',
        click_menu_dev_devProgs_DAU: 'click_menu_dev_devProgs_DAU',
        click_menu_dev_devProgs_TVL: 'click_menu_dev_devProgs_TVL',
        click_menu_dev_devProgs_TV: 'click_menu_dev_devProgs_TV',
        click_menu_dev_devProgs_allProgram: 'click_menu_dev_devProgs_allProgram',
        click_menu_dev_devProgs_GasGrant: 'click_menu_dev_devProgs_GasGrant',
        click_menu_dev_devProgs_Kickstart: 'click_menu_dev_devProgs_Kickstart',
        click_menu_dev_devProgs_MVB: 'click_menu_dev_devProgs_MVB',
        click_menu_dev_devProgs_BuilderGrants: 'click_menu_dev_devProgs_BuilderGrants',
        click_menu_dev_GitHub: 'click_menu_dev_GitHub',
        click_menu_dev_tools: 'click_menu_dev_tools',
        click_menu_dev_faucet: 'click_menu_dev_faucet',
        click_menu_dev_hackathon: 'click_menu_dev_hackathon',
        click_menu_dev_BNBChainList: 'click_menu_dev_BNBChainList',
        click_menu_dev_devProgs_SpaceB: 'click_menu_dev_devProgs_SpaceB',
        click_menu_dev_devProgs_MEME: 'click_menu_dev_devProgs_MEME',
        click_menu_dev_grants: 'click_menu_dev_grants',
        click_menu_community_governance: 'click_menu_community_governance',
    },
    doc: {
        click_menu_dev_doc_bsc: 'click_menu_dev_doc_bsc',
        click_menu_dev_doc_beacon: 'click_menu_dev_doc_beacon',
        click_menu_dev_doc_gf: 'click_menu_dev_doc_gf',
        click_menu_dev_doc_opBNB: 'click_menu_dev_doc_opBNB',
        click_menu_dev_doc_zkBNB: 'click_menu_dev_doc_zkBNB',
    },
    ecosystem: {
        click_menu_ecosystem: 'click_menu_ecosystem',
        click_menu_ecosystem_wallets: 'click_menu_ecosystem_wallets',
        click_menu_ecosystem_exploredApps: 'click_menu_ecosystem_exploredApps',
        click_menu_ecosystem_staking: 'click_menu_ecosystem_staking',
        click_menu_ecosystem_bridge: 'click_menu_ecosystem_bridge',
        click_menu_ecosystem_what: 'click_menu_ecosystem_what-is-bnb',
    },
    logo: {
        click_menu_home: 'click_menu_home',
    },
    solutions: {
        click_menu_solution: 'click_menu_solution',
        click_menu_solution_bsc: 'click_menu_solution_bsc',
        click_menu_solution_bsc_page: 'click_menu_solution_bsc_page',
        click_menu_solution_bsc_doc: 'click_menu_solution_bsc_doc',
        click_menu_solution_bsc_GitHub: 'click_menu_solution_bsc_GitHub',
        click_menu_solution_bsc_faucet: 'click_menu_solution_bsc_faucet',
        click_menu_solution_bsc_staking: 'click_menu_solution_bsc_staking',
        click_menu_solution_bsc_BscScan: 'click_menu_solution_bsc_BscScan',
        click_menu_solution_bsc_BSCTrace: 'click_menu_solution_bsc_BSCTrace',
        click_menu_solution_bsc_Bitquery: 'click_menu_solution_bsc_Bitquery',
        click_menu_solution_bsc_DevTools: 'click_menu_solution_bsc_DevTools',
        click_menu_solution_gf: 'click_menu_solution_gf',
        click_menu_solution_gf_page: 'click_menu_solution_gf_page',
        click_menu_solution_gf_doc: 'click_menu_solution_gf_doc',
        click_menu_solution_gf_GitHub: 'click_menu_solution_gf_GitHub',
        click_menu_solution_gf_GreenfieldScan: 'click_menu_solution_gf_GreenfieldScan',
        click_menu_solution_gf_dceller: 'click_menu_solution_gf_dceller',
        click_menu_solution_gf_faucet: 'click_menu_solution_gf_faucet',
        click_menu_solution_gf_bridge: 'click_menu_solution_gf_bridge',
        click_menu_solution_gf_DevTools: 'click_menu_solution_gf_DevTools',
        click_menu_solution_beacon_fusion: 'click_menu_solution_beacon_fusion',
        click_menu_solution_beacon_doc: 'click_menu_solution_beacon_doc',
        click_menu_solution_beacon_explorer: 'click_menu_solution_beacon_explorer',
        click_menu_solution_beacon_staking: 'click_menu_solution_beacon_staking',
        click_menu_solution_beacon_diExchanges: 'click_menu_solution_beacon_diExchanges',
        click_menu_solution_beacon_tokenRecoveryTool: 'click_menu_solution_beacon_tokenRecoveryTool',
        click_menu_solution_zkBNB_doc: 'click_menu_solution_zkBNB_doc',
        click_menu_solution_zkBNB_GitHub: 'click_menu_solution_zkBNB_GitHub',
        click_menu_solution_zkBNB: 'click_menu_solution_zkBNB',
        click_menu_solution_zkBNB_page: 'click_menu_solution_zkBNB_page',
        click_menu_solution_zkBNB_faucet: 'click_menu_solution_zkBNB_faucet',
        click_menu_solution_zkBNB_marketplace: 'click_menu_solution_zkBNB_marketplace',
        click_menu_solution_zkBNB_wallet: 'click_menu_solution_zkBNB_wallet',
        click_menu_solution_zkBNB_explorer: 'click_menu_solution_zkBNB_explorer',
        click_menu_solution_opBNB: 'click_menu_solution_opBNB',
        click_menu_solution_opBNB_page: 'click_menu_solution_opBNB_page',
        click_menu_solution_opBNB_doc: 'click_menu_solution_opBNB_doc',
        click_menu_solution_opBNB_GitHub: 'click_menu_solution_opBNB_GitHub',
        click_menu_solution_opBNB_bridge: 'click_menu_solution_opBNB_bridge',
        click_menu_solution_opBNB_faucet: 'click_menu_solution_opBNB_faucet',
        click_menu_solution_opBNB_explorer: 'click_menu_solution_opBNB_explorer',
        click_menu_solution_opBNB_DevTools: 'click_menu_solution_opBNB_DevTools',
        click_menu_solution_BNBSideChain_FNCYExplorer: 'click_menu_solution_BNBSideChain_FNCYExplorer',
        click_menu_solution_BNBSideChain_BNBChainList: 'click_menu_solution_BNBSideChain_BNBChainList',
        click_menu_solution_bsc_MetaMaskAddNetwork: 'click_menu_solution_bsc_MetaMaskAddNetwork',
        click_menu_solution_bsc_TWEAddNetwork: 'click_menu_solution_bsc_TWEAddNetwork',
        click_menu_solution_gf_MetaMaskAddNetwork: 'click_menu_solution_gf_MetaMaskAddNetwork',
        click_menu_solution_gf_TWEAddNetwork: 'click_menu_solution_gf_TWEAddNetwork',
        click_menu_solution_opBNB_MetaMaskAddNetwork: 'click_menu_solution_opBNB_MetaMaskAddNetwork',
        click_menu_solution_opBNB_TWEAddNetwork: 'click_menu_solution_opBNB_TWEAddNetwork',
    },
};
